import { useState } from 'react';

/**
 * Auf- oder zugeklappt, je Gerät gemerkt (`localStorage`). Nur eine
 * Bequemlichkeit: Ohne Speicher (privates Fenster) gilt die Vorgabe.
 */
export function useRememberedOpen(
  key: string,
  fallback: boolean,
): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored === null ? fallback : stored === '1';
    } catch {
      return fallback;
    }
  });
  const remember = (next: boolean) => {
    setOpen(next);
    try {
      localStorage.setItem(key, next ? '1' : '0');
    } catch {
      // Ohne Speicher bleibt es bei der Vorgabe.
    }
  };
  return [open, remember];
}
